// extracted by mini-css-extract-plugin
export default {"container":"catalog-children-page_container__Nk7kz","wrapper":"catalog-children-page_wrapper__PJCZQ","item_page":"catalog-children-page_item_page__tm6MD"};